import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('proposal-models', storeModule.createStoreModule('proposal-models'))
